module.exports = __webpack_public_path__ + "img/ic_food_canteen_right_img.5e67f110.png";